import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

import './DatapointsExportModalFooter.scss';

function DatapointsExportModalFooter({ applyDatapoints, cancelDatapoints }) {
  return (
    <div className="exportModal__footer datapointsExportModal__footer">
      <div className="datapointsExportModal__footer_buttons">
        <Button
          data-e2e="export-modal-cancel"
          type="secondary"
          size="small"
          aria-label="Cancel"
          onClick={cancelDatapoints}
          className="e2e-export-modal-cancel">
          Cancel
        </Button>

        <Button
          data-e2e="export-modal-add-datapoints"
          type="primary"
          size="small"
          aria-label="Add datapoints"
          onClick={applyDatapoints}
          className="e2e-export-modal-apply">
          Add datapoints
        </Button>
      </div>
    </div>
  );
}

DatapointsExportModalFooter.propTypes = {
  applyDatapoints: PropTypes.func.isRequired,
  cancelDatapoints: PropTypes.func.isRequired,
};

export default DatapointsExportModalFooter;
